import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "20",
  height: "11.883",
  rx: "2",
  fill: "#2AC72A",
  "fill-opacity": ".1"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15.004 9.883H4.995a.997.997 0 0 1-.75-1.65l5.133-5.892a.995.995 0 0 1 1.517.02l4.843 5.853a.996.996 0 0 1-.734 1.67Z",
  fill: "#2AC72A"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("rect", {
  width: "20",
  height: "11.883",
  rx: "2",
  transform: "matrix(1 0 0 -1 0 29.768)",
  fill: "#CF4F4F",
  "fill-opacity": ".1"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15.004 19.884H4.995a.997.997 0 0 0-.75 1.65l5.133 5.892a.995.995 0 0 0 1.517-.02l4.843-5.853a.996.996 0 0 0-.734-1.67Z",
  fill: "#CF4F4F"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render };